const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const TURNSTILE_READY_TIMEOUT_MS = 15000;
let scriptLoadPromise = null;
const findTurnstileScript = () => document.querySelector('script[data-turnstile="true"]') ||
    document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
const removeTurnstileScripts = () => {
    document.querySelectorAll('script[data-turnstile="true"]').forEach((node) => node.remove());
    document
        .querySelectorAll('script[src*="challenges.cloudflare.com/turnstile"]')
        .forEach((node) => node.remove());
    delete window.turnstile;
};
const whenTurnstileReady = (api, timeoutMs) => new Promise((resolve, reject) => {
    if (typeof api.render === 'function' && typeof api.ready !== 'function') {
        resolve(api);
        return;
    }
    if (typeof api.ready !== 'function') {
        resolve(api);
        return;
    }
    let settled = false;
    const timeout = window.setTimeout(() => {
        if (settled)
            return;
        settled = true;
        if (typeof api.render === 'function') {
            resolve(api);
            return;
        }
        reject(new Error('turnstile_api_timeout'));
    }, timeoutMs);
    try {
        api.ready(() => {
            if (settled)
                return;
            settled = true;
            window.clearTimeout(timeout);
            resolve(api);
        });
    }
    catch {
        window.clearTimeout(timeout);
        if (typeof api.render === 'function') {
            resolve(api);
            return;
        }
        reject(new Error('turnstile_ready_failed'));
    }
});
const waitForTurnstileApi = (timeoutMs) => new Promise((resolve, reject) => {
    const started = Date.now();
    const tick = () => {
        const api = window.turnstile;
        if (api) {
            void whenTurnstileReady(api, Math.max(500, timeoutMs - (Date.now() - started)))
                .then(resolve)
                .catch(reject);
            return;
        }
        if (Date.now() - started >= timeoutMs) {
            reject(new Error('turnstile_api_timeout'));
            return;
        }
        window.setTimeout(tick, 50);
    };
    tick();
});
const injectTurnstileScript = () => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = TURNSTILE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.dataset.turnstile = 'true';
    script.onload = () => {
        void waitForTurnstileApi(TURNSTILE_READY_TIMEOUT_MS).then(resolve).catch(reject);
    };
    script.onerror = () => {
        script.dataset.failed = 'true';
        reject(new Error('turnstile_script_failed'));
    };
    document.head.appendChild(script);
});
export const loadTurnstileScript = () => {
    if (scriptLoadPromise)
        return scriptLoadPromise;
    scriptLoadPromise = new Promise((resolve, reject) => {
        const existing = findTurnstileScript();
        if (existing?.dataset.failed === 'true') {
            scriptLoadPromise = null;
            reject(new Error('turnstile_script_failed'));
            return;
        }
        if (existing) {
            void waitForTurnstileApi(TURNSTILE_READY_TIMEOUT_MS).then(resolve).catch((error) => {
                scriptLoadPromise = null;
                reject(error);
            });
            return;
        }
        void injectTurnstileScript()
            .then(resolve)
            .catch((error) => {
            scriptLoadPromise = null;
            reject(error);
        });
    });
    return scriptLoadPromise;
};
export const reloadTurnstileScript = async () => {
    resetTurnstileScriptLoader();
    removeTurnstileScripts();
    return loadTurnstileScript();
};
export const resetTurnstileScriptLoader = () => {
    scriptLoadPromise = null;
};
export const getTurnstileApi = () => window.turnstile;
